import { useTranslation } from 'react-i18next'

import { Input, InputNumber, Label, Select } from '@mercai/clever'
import { LeadPurchaseFrequencyEnum } from '@/types'

import { ProfileConsumptionFormProps } from './consumption-form.type'

import styles from './consumption-form.module.css'

export const ProfileConsumptionForm = ({
  onValuesChange,
  values,
}: ProfileConsumptionFormProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('screenProfileShow')

  const handleOnChangeValues = (
    key: string,
    value: string | number | boolean,
  ) => {
    onValuesChange({ ...values, [key]: value })
  }

  return (
    <div className={styles.core}>
      <div className={styles['form-group']}>
        <Label>{t('consumptionFormConsumptionMonthlyLabel')}</Label>
        <Input
          value={values?.monthlyBuyingPotential}
          onChange={(value) =>
            handleOnChangeValues('monthlyBuyingPotential', value)
          }
        />
      </div>

      <div className={styles['form-group']}>
        <Label>{t('consumptionFormFrequencyLabel')}</Label>
        <Select
          value={values?.purchaseFrequency}
          onChange={(value) => handleOnChangeValues('purchaseFrequency', value)}
          options={[
            { value: '', label: t('selectOptionEmpty') },
            ...Object.keys(LeadPurchaseFrequencyEnum).map((key) => ({
              value: key,
              label: tEnums(`lead_frequency_${key}`),
            })),
          ]}
          placeholder={t('selectPlaceholder')}
        />
      </div>

      <div className={styles['form-group']}>
        <Label>{t('consumptionFormAgeLabel')}</Label>
        <InputNumber
          decimalPrecision={0}
          showIcons
          suffix={t('consumptionFormAgeSufixLabel')}
          value={values?.companyAge}
          onChange={(value) => handleOnChangeValues('companyAge', value)}
        />
      </div>
    </div>
  )
}
